// extracted by mini-css-extract-plugin
export default {"container":"_9dc1fbdf38c20626","header":"c8883256ed449c1b","body":"_27d4b8e4949893d9","loader":"_4e8df5d708a1643f"};